import { Action } from '@ngrx/store';
import { type } from "../../types";
import { PageItem } from "common-lib";


export const ActionTypes = {
  SHOW_LOADING: type('[app] [UI] Loading show'),
  HIDE_LOADING: type('[app] [UI] Loading hide'),
  SET_ENABLED_ENTRY_PAGES: type('[app] [UI] Set enabled entry pages'),
  INCREASE_LOADING_COUNTER: type('[app] [UI] Increase loading counter'),
  DECREASE_LOADING_COUNTER: type('[app] [UI] Decrease loading counter')
};

export class ShowLoadingAction implements Action {
  type = ActionTypes.SHOW_LOADING;

  constructor() {
  }
}

export class HideLoadingAction implements Action {
  type = ActionTypes.HIDE_LOADING;

  constructor() {
  }
}

export class SetAvailableEntryPagesAction implements Action {
  type = ActionTypes.SET_ENABLED_ENTRY_PAGES;

  constructor(public readonly payload: PageItem[]) {
  }
}

export class IncreaseLoadingCounterAction implements Action {
  type = ActionTypes.INCREASE_LOADING_COUNTER;

  constructor(public readonly payload: string) {
  }
}

export class DecreaseLoadingCounterAction implements Action {
  type = ActionTypes.DECREASE_LOADING_COUNTER;

  constructor(public readonly payload: string) {
  }
}

export declare type UiActions =
  ShowLoadingAction
  | HideLoadingAction
  | SetAvailableEntryPagesAction
  | IncreaseLoadingCounterAction
  | DecreaseLoadingCounterAction;


